<NavBar screenTitle="Favorite Lineups"/>
<div class='columns is-marginless'>
    <div class='column is-half'>
        <nav class='panel'>
            <div class='panel-heading has-background-primary has-text-white'>
                Favorites
            </div>
            {#each Object.keys($bookmarkedLineups) as name}
            <div class='panel-block {name == bookmarkName ? "has-background-grey-light": ""}' on:click="set({bookmarkName: name})">
                <div class='is-full-width'>
                    {name}
                    <span class='panel-icon is-pulled-right has-text-danger' on:click="removeBookmark(name)">
                        <i class="fas fa-lg fa-times-circle" aria-hidden="true"></i>
                    </span>
                </div>
            </div>
            {/each}
        </nav>
    </div>
    <div class='column is-half'>
        <nav class='panel'>
            <div class='panel-heading has-background-primary has-text-white'>
                Lineup
            </div>
            <p class='panel-block roster-player'>
                <span class='panel-icon lineup-id'>P</span>
                {#if inning && inning[1].last}
                    {inning[1].last}
                {:else}
                    &nbsp;
                {/if}
            </p>
            <p class='panel-block roster-player'>
                <span class='panel-icon lineup-id'>C</span>
                {#if inning && inning[2].last}
                    {inning[2].last}
                {:else}
                    &nbsp;
                {/if}
            </p>
            <p class='panel-block roster-player'>
                <span class='panel-icon lineup-id'>1st</span>
                {#if inning && inning[3].last}
                    {inning[3].last}
                {:else}
                    &nbsp;
                {/if}
            </p>
            <p class='panel-block roster-player'>
                <span class='panel-icon lineup-id'>2nd</span>
                {#if inning && inning[4].last}
                    {inning[4].last}
                {:else}
                    &nbsp;
                {/if}
            </p>
            <p class='panel-block roster-player'>
                <span class='panel-icon lineup-id'>3rd</span>
                {#if inning && inning[5].last}
                    {inning[5].last}
                {:else}
                    &nbsp;
                {/if}
            </p>
            <p class='panel-block roster-player'>
                <span class='panel-icon lineup-id'>SS</span>
                {#if inning && inning[6].last}
                    {inning[6].last}
                {:else}
                    &nbsp;
                {/if}
            </p>
            <p class='panel-block roster-player'>
                <span class='panel-icon lineup-id'>LF</span>
                {#if inning && inning[7].last}
                    {inning[7].last}
                {:else}
                    &nbsp;
                {/if}
            </p>
            <p class='panel-block roster-player'>
                <span class='panel-icon lineup-id'>CF</span>
                {#if inning && inning[8].last}
                    {inning[8].last}
                {:else}
                    &nbsp;
                {/if}
            </p>
            <p class='panel-block roster-player'>
                <span class='panel-icon lineup-id'>RF</span>
                {#if inning && inning[9].last}
                    {inning[9].last}
                {:else}
                    &nbsp;
                {/if}
            </p>
        </nav>
    </div>
</div>

<script>
    import NavBar from './NavBar.html';

    export default {
        data() {
            return {
                bookmarkName: ''
            }
        },
        computed: {
            inning: ({$bookmarkedLineups, bookmarkName}) => $bookmarkedLineups[bookmarkName]
        },
        methods: {
            removeBookmark(bookmarkName) {
                let {bookmarkedLineups} = this.store.get();
                delete(bookmarkedLineups[bookmarkName]);
                this.store.set({bookmarkedLineups});
            }
        },
		components: {
            NavBar
		}
	};

</script>

<style>
    .roster-player {
        display: block;
        padding: 0.4em 0.75em;
    }
    .fa-lg {
        line-height: 1.33333em;
    }
    .panel-icon {
        vertical-align: inherit;
    }
</style>
